import axios from 'axios'
import { IUnit } from './Units'

const server = process.env.REACT_APP_SERVER_URL

export const createAssembly = async (
  assembly: ICreateAssemblyDTO
): Promise<IAssemblyDTO> => {
  try {
    const response = await axios.post<ICreateAssemblyResponseDTO>(
      `${server}/inventory/assembly`,
      {
        assembly,
      }
    )
    return response.data.newAssembly
  } catch (error) {
    throw error
  }
}

export const removeAssembly = async (
  id: string
): Promise<IAssemblyUpdateDeleteDTO> => {
  try {
    const response = axios.delete<IDeleteAssmblyResponseDTO>(
      `${server}/inventory/assembly/${id}`
    )
    return (await response).data.deletedAssemblyItem
  } catch (error) {
    throw error
  }
}

export const updateAssembly = async (
  assembly: IUpdateAssemblyDTO
): Promise<IAssemblyUpdateDeleteDTO> => {
  try {
    const response = axios.patch<IUpdateAssmblyResponseDTO>(
      `${server}/inventory/assembly`,
      {
        assembly,
      }
    )
    return (await response).data.updatedAssembly
  } catch (error) {
    throw error
  }
}

interface ICreateAssemblyDTO {
  assemblyItem: {
    id: string
  }
  productionItem: {
    id: string
  }
  amount: number
}

interface IUpdateAssemblyDTO {
  id: string
  amount: number
}

interface ICreateAssemblyResponseDTO {
  status: number
  message: string
  newAssembly: IAssemblyDTO
}

interface IDeleteAssmblyResponseDTO {
  status: number
  message: string
  deletedAssemblyItem: IAssemblyUpdateDeleteDTO
}

interface IUpdateAssmblyResponseDTO {
  status: number
  message: string
  updatedAssembly: IAssemblyUpdateDeleteDTO
}

interface IAssemblyDTO {
  id: string
  assemblyItem: {
    id: string
  }
  productionItem: {
    id: string
    availableQuantity: number
    cost: string
    exempt: boolean
    name: string
    price: string
    requiredQuantity: string
    unit: {
      id: string
      abbreviatedName: string
    }
  }
}

interface IAssemblyUpdateDeleteDTO {
  id: string
  assemblyItem: {
    id: string
  }
  productionItem: {
    id: string
    availableQuantity: number
    cost: string
    exempt: boolean
    name: string
    price: string
    requiredQuantity: string
  }
}
